<template>
  <div class="main-wrapper coffee-shop">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
              <div class="inv-details">
                <div class="inv-date">Date: <span>05/12/2022</span></div>
                <div class="inv-date inv-no mb-0">Invoice No: <span>INV 00001</span></div>
              </div>
            </div>
            <div class="inv-header-right">
              <div class="invoice-title tax-invoice">TAX INVOICE</div>
              <div class="company-details">
                <span class="company-name invoice-title"> Dreamguys Cafe </span>
                <div class="gst-details">
                  Address:
                  <span>15 Hodges Mews, High Wycombe HP12 3JL, United Kingdom.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-address">
            <div class="invoice-to">
              <span>Customer Info:</span>
              <span class="invoice-title">John Williams</span>
            </div>
          </div>
          <div class="invoice-table">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr class="coffee-shop">
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Item</th>
                    <th class="text-center">Rate/Item</th>
                    <th class="text-center">Qty</th>
                    <th class="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">
                      Colombia Dark Roast<span>22 July 2022 at 2.30pm</span>
                    </td>
                    <td class="text-center">$200</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$200</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">
                      Coffee Mug<span>22 July 2022 at 2.30pm</span>
                    </td>
                    <td class="text-center">$200</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$200</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="table-description">
                      Medium Cafe Mocha<span>22 July 2022 at 2.30pm</span>
                    </td>
                    <td class="text-center">$200</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$200</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer border border-0 py-0">
            <div class="table-footer-left notes"></div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>₹600.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer pt-0">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>₹6.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer table-total-item">
            <div class="table-footer-left">
              <span class="total-item">Total Items / Qty : 3 / 3.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Total Amount</td>
                    <td class="invoice-title">₹606.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="total-amountdetails">
            <p>
              Total amount ( in words): <span>INR Six Hundred Six Dollers Only.</span>
            </p>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div class="mb-0"><span>Amount :</span> $1,815</div>
            </div>
            <div class="terms-condition">
              <span>Terms & Conditions:</span>
              <ol>
                <li>Goods Once sold cannot be taken back or exchanged</li>
                <li>
                  We are not the manufactures, company will stand for warrenty as per
                  their terms and conditions.
                </li>
              </ol>
            </div>
          </div>
          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
